/**
 * Created by Bart Decorte
 * Date: 13/11/2018
 * Time: 12:17
 */
import Page from './Page';
import * as Ladda from 'ladda';
import Filter from '../filters/Filter';
import DateFilter from '../filters/DateFilter';
import DateTimeFilter from '../filters/DateTimeFilter';
import DropdownFilter from '../filters/DropdownFilter';
import TimeFilter from '../filters/TimeFilter';
import {stringStudly} from '../helpers/string_helper';

class IndexPage extends Page {
  constructor(params = {}) {
    super(params);
    this.$root = params.$root;
    this.filters = {};
    this.activeFilter;
    this.$filterRoot = $('.filter-menu');
    this.$filterAdd = this.$filterRoot.find('#filter-add');
    this.$filterSubmit = this.$filterRoot.find('button[type="submit"]');
    this.loadingButton = Ladda.create(this.$filterSubmit.get(0));

    this.initFilters();
    this.bindListeners();
  }

  filterClasses() {
    return {
      DateFilter,
      DateTimeFilter,
      DropdownFilter,
      Filter,
      TimeFilter,
    };
  }

  initFilters() {
    const $options = this.$filterAdd.find('option:not([disabled])');
    for (let i = 0; i < $options.length; i++) {
      const $option = $($options[i]);
      const key = $option.val();
      const type = $option.data('type');
      const typeStudly = type ? stringStudly(type) : '';
      let filterClass = this.filterClasses()[`${typeStudly}Filter`];
      filterClass = filterClass || Filter;
      this.filters[key] = new filterClass($(`.js-filter[data-key="${key}"]`));
    }
    return this;
  }

  bindListeners() {
    let $body = $('body');
    this.$filterRoot.off('blur');
    this.$filterRoot.on('click', (ev) => this.lDropDownClicked(ev));
    this.$filterAdd.on('change', (ev) => this.lFilterTypeChanged(ev));
    $body
      .find('[data-filters]')
      .not('[data-filter-descendants]')
      .on('change', (ev) => this.lFilterChanged(ev));
    $body
      .find('.js-applied-filter')
      .on('click', (ev) => this.lAppliedFilterClicked(ev));
    this.$filterSubmit.on('click', (ev) => this.lFilterSubmitted(ev));
  }

  lDropDownClicked(ev) {
    ev.preventDefault();
    return false;
  }

  lFilterTypeChanged(ev) {
    if (this.activeFilter) {
      this.activeFilter.destroy();
    }

    let activeKey = this.$filterAdd.val();
    this.activeFilter = this.filters[activeKey];
    if (this.activeFilter) {
      this.activeFilter.init();
    }
    let $filterInputs = this.$filterRoot.find('[data-filters]');

    for (let i = 0; i < $filterInputs.length; i++) {
      if (!$($filterInputs[i]).hasClass('d-none')) {
        $($filterInputs[i]).addClass('d-none');
      }
    }

    let $childInputs = $filterInputs.not('[data-filter-descendants]');
    for (let i = 0; i < $childInputs.length; i++) {
      if (this.hasFilterType($($childInputs[i]), activeKey)) {
        $($childInputs[i])
          .removeClass('d-none')
          .find('select')
          .trigger('change');
      }
    }
  }

  lFilterChanged(ev) {
    let filterType = this.$filterAdd.val();
    let $filter = $(ev.target);
    let descendant = $filter.val();

    let $descendants = $('[data-filter-descendants]');
    for (let i = 0; i < $descendants.length; i++) {
      let $descendant = $($descendants[i]);
      if (
        this.hasFilterType($descendant, filterType) &&
        this.hasFilterDescendant($descendant, descendant) &&
        $descendant.hasClass('d-none')
      ) {
        $descendant.removeClass('d-none');
      } else if (
        !(
          this.hasFilterType($descendant, filterType) &&
          this.hasFilterDescendant($descendant, descendant)
        ) &&
        !$descendant.hasClass('d-none')
      ) {
        $descendant.addClass('d-none');
      }
    }
  }

  lAppliedFilterClicked(ev) {
    let $elt = $(ev.target).hasClass('js-applied-filter')
      ? $(ev.target)
      : $(ev.target)
          .parents('.js-applied-filter')
          .first();

    $elt.find('.filter-deleted').val(1);
    $elt.addClass('d-none');
  }

  lFilterSubmitted(ev) {
    this.loadingButton.start();
    $(ev.target)
      .parents('form')
      .first()
      .submit();
  }

  hasFilterType($elt, type) {
    if (typeof $elt.data('filters') === typeof undefined) {
      return false;
    }

    const types = $elt
      .data('filters')
      .toString()
      .split(',');
    if (!types.length) {
      return false;
    }

    for (let i = 0; i < types.length; i++) {
      if (types[i] === type) {
        return true;
      }
    }
    return false;
  }

  hasFilterDescendant($elt, descendant) {
    if (typeof $elt.data('filter-descendants') === typeof undefined) {
      return false;
    }

    if (!descendant.length) {
      return false;
    }

    let descendants = $elt.data('filter-descendants').split(',');

    if (!descendants.length) {
      return false;
    }

    for (let i = 0; i < descendants.length; i++) {
      if (descendants[i] === descendant) {
        return true;
      }
    }

    return false;
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/IndexPage.js